import { all, fork } from "redux-saga/effects";

//public
import AuthSaga from "./Auth/saga";

export default function* rootSaga() {
  yield all([fork(AuthSaga)]);
}
